/* Codigo de cyr-precio-cliente (el precio de cliente durante 24h tras comprar).
   Desde el 4-sep-2026 el porcentaje NO es fijo: lo trae el propio pase (var PCT).
   Al que compro con un 25% se le premia con un 30%, al del 22% con un 27%...
   Estaba dentro del snippet y viajaba en el HTML de TODAS las paginas para todos los visitantes.
   Movido a fichero el 24-ago-2026: mismo codigo, sin un caracter de diferencia, pero se cachea.
   La logica NO se ha tocado: se sigue cargando en todas las paginas, como antes. */
(function(){
  try{
    var qs = new URLSearchParams(location.search);
    var q  = qs.get('pc');

    if(q==='off'){ document.cookie='cyr_pc=; path=/; max-age=0'; return; }

    // ── 1. Guardar/leer el "pase" del cliente
    function ck(n){ var m=document.cookie.match(new RegExp('(?:^|;\\s*)'+n+'=([^;]+)')); return m?decodeURIComponent(m[1]):null; }
    var pase=null;
    if(q){
      // El fin puede venir en el enlace (h=epoch_ms). Si no viene —el correo no
      // siempre puede calcularlo—, contamos 24 h desde el primer clic.
      var fin = parseInt(qs.get('h')||'0',10);
      if(!fin || isNaN(fin)) fin = Date.now() + 24*60*60*1000;
      // El rebote por /discount/ vuelve a codificar la URL, así que un
      // "Córdoba" puede llegar como "C%C3%B3rdoba". Se decodifica lo que haga falta.
      function limpiaParam(v){
        v = v || '';
        for(var i=0;i<3 && /%[0-9A-Fa-f]{2}/.test(v);i++){
          try{ var d=decodeURIComponent(v); if(d===v) break; v=d; }catch(e){ break; }
        }
        return v.slice(0,40);
      }
      // Los datos de escaparate ya no viajan a la vista: vienen cerrados en
      // 'k' y los abre el servidor. Los parámetros sueltos se siguen leyendo
      // por si queda algún enlace antiguo dando vueltas.
      // `p` son los puntos de descuento de SU codigo. Desde el 4-sep-2026 el
      // premio ya no es un 20 para todos: al que compro con un 25 se le da un
      // 30, al del 22 un 27... Si el enlace no lo trae (pase viejo, de antes
      // del cambio) se queda en 20, que es lo que valian todos hasta ahora.
      pase={ code:q, end:fin, k:qs.get('k')||'', pct:(parseInt(qs.get('p')||'0',10)||0),
             name:limpiaParam(qs.get('n')), city:limpiaParam(qs.get('c')),
             t:limpiaParam(qs.get('t')), v:limpiaParam(qs.get('v')), ph:limpiaParam(qs.get('ph')), nq:parseInt(qs.get('nq')||'1',10)||1 };
      var restante=Math.floor((pase.end-Date.now())/1000);
      if(restante>0){
        document.cookie='cyr_pc='+encodeURIComponent(JSON.stringify(pase))+'; path=/; max-age='+restante;
      }
    } else {
      try{ pase=JSON.parse(ck('cyr_pc')||'null'); }catch(e){ pase=null; }
    }
    if(!pase || !pase.code || !pase.end) return;

    // ── LO QUE VALE SU PASE ───────────────────────────────────────────────
    // Aqui habia un 20 escrito a fuego en once sitios. Ahora el numero lo trae
    // el propio pase. Se acota a lo razonable: si llegara un valor absurdo por
    // la URL se pintarian precios que Shopify no va a cobrar, que es la unica
    // cosa que este fichero tiene prohibido hacer.
    var PCT = (pase.pct >= 5 && pase.pct <= 60) ? Math.round(pase.pct) : 20;
    var PCTX = '\u2212' + PCT + '%';   // "-30%" tal y como se le ense\u00f1a

    // ── 2. Caducado → limpiar y salir
    if(Date.now() >= pase.end){ document.cookie='cyr_pc=; path=/; max-age=0'; return; }

    // ── 3. Si la promo general está activa, no duplicamos descuentos
    if(/(^|;\s*)cyr_promo=verano/.test(document.cookie)) return;

    document.documentElement.classList.add('cyr-pc-on');
    // El carrito lo lee para saber si tiene que prometer la devolución del
    // segundo porte (Canarias, Baleares, Ceuta y Melilla).
    window.CYR_PORTE_ANTERIOR = 0;

    // ── 4. Activar el código en la sesión de Shopify (una sola vez)
    if(q && !ck('cyr_pc_aplicado')){
      document.cookie='cyr_pc_aplicado=1; path=/; max-age='+(60*60*24);
      var vuelta = location.pathname + (location.search ? location.search : '');
      location.replace('/discount/'+encodeURIComponent(pase.code)+'?redirect='+encodeURIComponent(vuelta));
      return;
    }

    // ── 4bis. Abrir el sobre con sus datos de escaparate
    // Ojo al orden: esto va DESPUÉS del rebote a /discount/. El descuento ya
    // está aplicado a estas alturas, así que si esta llamada falla el cliente
    // pierde su nombre en el titular, nunca su precio.
    var HOST_PASE = 'https://gestor.cortayrecorta.es';
    function guardarPase(){
      var restante = Math.floor((pase.end - Date.now())/1000);
      if(restante > 0){
        try{ document.cookie = 'cyr_pc=' + encodeURIComponent(JSON.stringify(pase)) + '; path=/; max-age=' + restante; }catch(e){}
      }
    }

    // ¿Falta abrirlo? Solo si hay sobre y todavía no tenemos los datos.
    if(pase.pe) window.CYR_PORTE_ANTERIOR = pase.pe;
    var esperandoPase = !!(pase.k && !pase.abierto);
    if(esperandoPase){
      var listo = false;
      var seguir = function(){
        if(listo) return; listo = true;
        pase.abierto = 1;      // no se vuelve a pedir en esta sesión
        window.CYR_PORTE_ANTERIOR = pase.pe || 0;
        // El nombre se calcula más abajo, y para entonces el sobre todavía no
        // había llegado: hay que rehacerlo o el titular se queda sin él.
        nombre = (pase.name||'').trim().split(/\s+/)[0] || '';
        if(nombre) nombre = nombre.charAt(0).toUpperCase() + nombre.slice(1).toLowerCase();
        guardarPase();
        arrancarPintado();
      };
      // Si el servidor no contesta en 2,5 s se pinta igual, sin su nombre.
      setTimeout(seguir, 2500);
      try{
        fetch(HOST_PASE + '/api/public/pase?k=' + encodeURIComponent(pase.k), { credentials:'omit' })
          .then(function(r){ return r.json(); })
          .then(function(d){
            if(d && d.ok){
              pase.name = (d.n||'').slice(0,40);
              pase.city = (d.c||'').slice(0,40);
              pase.t    = (d.t||'').slice(0,70);
              pase.v    = (d.v||'').slice(0,40);
              pase.ph   = (d.ph||'').slice(0,60);
              pase.nq   = parseInt(d.nq||'1',10)||1;
              pase.pe   = parseFloat(d.pe||0) || 0;
            }
            seguir();
          })
          .catch(seguir);
      }catch(e){ seguir(); }
    }

    // ── 5. Barra: le hablamos a ÉL por su nombre, no a "un cliente"
    function dos(n){ return (n<10?'0':'')+n; }
    // Solo el nombre de pila, y con la inicial en mayúscula
    var nombre = (pase.name||'').trim().split(/\s+/)[0] || '';
    if(nombre) nombre = nombre.charAt(0).toUpperCase()+nombre.slice(1).toLowerCase();

    function pintarBarra(){
      if(document.querySelector('.cyr-pc-bar')) return;
      var b=document.createElement('div');
      b.className='cyr-pc-bar';
      var cabecera = nombre
        ? '<span class="cyr-pc-name">'+nombre+'</span>, te quedan <b class="cyr-pc-cd">—</b>'
        : 'Te quedan <b class="cyr-pc-cd">—</b>';
      b.innerHTML = cabecera + ' con tu <b>' + PCTX + '</b>'
        + '<span class="cyr-pc-sub">Tu pedido sigue sin cerrar · lo que añadas viaja en el mismo envío</span>';
      document.body.insertBefore(b, document.body.firstChild);
    }

    // Su ciudad, si el correo la manda: "llega a Córdoba con el tuyo"
    var ciudad = (pase.city||'').trim();
    if(ciudad) ciudad = ciudad.charAt(0).toUpperCase()+ciudad.slice(1);
    var destino = ciudad ? ('llega a '+ciudad+' con el tuyo') : 'viaja con el tuyo';

    // Su nombre donde decide: en la ficha, junto al precio
    function pintarFicha(){
      if(!/\/products\//.test(location.pathname)) return;
      if(document.querySelector('.cyr-pc-ficha')) return;
      // Detrás de la fila del tachado, si no se cuela entre el precio y su tachado
      var ancla = document.querySelector('.cyr-pc-fila') || document.getElementById('cr-dynamic-price') || document.querySelector('.product-info .price, .product-info__price');
      if(!ancla) return;
      var d=document.createElement('div');
      d.className='cyr-pc-ficha';
      d.style.cssText='margin:10px 0 4px;padding:9px 12px;border-radius:10px;background:rgba(20,20,20,.05);font-size:13.5px;line-height:1.45;font-weight:600';
      d.innerHTML = (nombre ? nombre+', este ' : 'Este ') + destino + ' con <b>' + PCTX + '</b>. '
        + '<span style="opacity:.7">Un solo envío, un solo embalaje.</span>';
      (ancla.parentNode||document.body).insertBefore(d, ancla.nextSibling);
    }

    // Bloque de "no arriesgas nada" — con datos REALES de la tienda
    // (1 de cada 100 devuelve · recogida gratis en su puerta)
    function pintarSinRiesgo(){
      if(!/\/products\//.test(location.pathname)) return;
      if(document.querySelector('.cyr-pc-riesgo')) return;
      var ancla = document.querySelector('.cyr-pc-ficha'); if(!ancla) return;
      var d=document.createElement('div');
      d.className='cyr-pc-riesgo';
      d.style.cssText='margin:8px 0 4px;padding:9px 12px;border-radius:10px;border:1px dashed rgba(20,20,20,.25);font-size:13px;line-height:1.5';
      d.innerHTML = '<b>Uno de cada cinco se lleva más de uno de una vez.</b> Y no arriesgas nada: '
        + 'de cada cien que compran, uno lo devuelve. Si eres ese uno, paso yo a recogerlo a tu puerta '
        + 'y no te cuesta un céntimo. Si al final los dos no encajan, me devuelves los dos.';
      ancla.parentNode.insertBefore(d, ancla.nextSibling);
    }

    // ── PORTADA: su cuadro, a sangre y con el idioma de la casa ──────────
    // La web habla en mayúsculas condensadas sobre negro ("NO DECORES.
    // IMPACTA"). Esto tiene que sonar igual, no a banner pegado.
    var fotoSuya = null, fotoPedida = false;
    function pedirFoto(){
      if(fotoPedida || !pase.ph) return;
      fotoPedida = true;
      fetch('/products/' + pase.ph + '.js')
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(p){ if(p && p.featured_image){ fotoSuya = p.featured_image; pintarHome(true); } })
        .catch(function(){});
    }

    function esPortada(){
      return location.pathname === '/' || /^\/(es|en)\/?$/.test(location.pathname);
    }

    function pintarHome(rehacer){
      if(!esPortada()) return;
      var ya = document.querySelector('.cyr-pc-home');
      if(ya && !rehacer) return;
      pedirFoto();
      var main = document.querySelector('main') || document.body;
      if(!main) return;

      var suyo   = (pase.t || '').replace(/^"|"$/g, '');
      var medida = pase.v || '';
      var varios = (pase.nq || 1) > 1;

      // "Panorámico / 170x67 Cm" → forma y medida por separado
      var esPersonalizado = /personaliz/i.test(suyo);
      var forma = '', tam = '';
      if(medida.indexOf('/') > -1){
        var trozos = medida.split('/');
        forma = trozos[0].trim();
        tam = trozos[1].trim();
      } else { tam = medida; }

      // Titular: su nombre primero, y el remate en oro
      var h0 = nombre ? (nombre.toUpperCase() + ',') : '';
      var h1, h2;
      if(esPersonalizado){
        h1 = forma ? ('TU ' + forma.toUpperCase()) : 'LO TUYO';
        h2 = 'YA ESTÁ EN MARCHA';
      } else if(varios){
        h1 = 'TUS CUADROS';
        h2 = 'YA ESTÁN AQUÍ';
      } else {
        h1 = 'TU CUADRO';
        h2 = 'YA ESTÁ AQUÍ';
      }

      // Muy claro y muy corto: lo que sigue abierto es SU PAQUETE, aquí,
      // encima de la mesa. Sin eso el cliente no entiende de qué le hablas.
      var cuerpo = esPersonalizado
        ? 'Elegiste bien la medida. Y mientras lo fabrico, <b>tu paquete sigue abierto</b> encima de mi mesa: lo que añadas ahora entra dentro y ' + destino + '.'
        : (varios
            ? '<b>Tu paquete sigue abierto</b> encima de mi mesa, sin precintar. Lo que añadas ahora entra dentro y ' + destino + ': un solo envío, un solo porte.'
            : '<b>Tu paquete sigue abierto</b> encima de mi mesa, sin precintar. Lo que elijas ahora entra dentro y ' + destino + ': un solo envío, un solo porte.');

      var ficha = suyo
        ? '<div class="cyr-h__ficha">'
            + '<span class="cyr-h__ficha-t">' + suyo + '</span>'
            + (tam ? '<span class="cyr-h__ficha-m">' + (forma ? forma + ' · ' : '') + tam + '</span>' : '')
          + '</div>'
        : '';

      var img = fotoSuya
        ? '<div class="cyr-h__img"><img src="' + fotoSuya + '&width=900" alt=""></div>'
        : '';

      var html =
        '<section class="cyr-h' + (img ? '' : ' cyr-h--solo') + '">'
        + img
        + '<div class="cyr-h__panel">'
          + '<div class="cyr-h__eyebrow">Tu precio · no está en la web pública</div>'
          + '<h2 class="cyr-h__h">' + (h0 ? '<span class="cyr-h__h-n">' + h0 + '</span>' : '') + '<span>' + h1 + '</span><span>' + h2 + '</span></h2>'
          + ficha
          + '<p class="cyr-h__p">' + cuerpo + '</p>'
          + '<div class="cyr-h__reloj">'
            + '<span class="cyr-h__reloj-l">Lo precinto en</span>'
            + '<span class="cyr-h__reloj-n cyr-pc-cd">—</span>'
          + '</div>'
          + '<a class="cyr-h__btn" href="/collections/all">Elegir otro con mi ' + PCTX + '<i>→</i></a>'
          + '<p class="cyr-h__pie">Uno de cada cinco se lleva más de uno de una vez. Y de cada cien, uno lo devuelve: si eres ese uno, paso yo a recogerlo. Gratis.</p>'
        + '</div>'
      + '</section>';

      if(ya){ ya.innerHTML = html; return; }
      var d = document.createElement('div');
      d.className = 'cyr-pc-home';
      d.innerHTML = html;
      main.insertBefore(d, main.firstChild);
    }

    // ── Colecciones: no es un catálogo, es su segunda pieza ───────────────
    function pintarColeccion(){
      if(!/\/collections\//.test(location.pathname)) return;
      if(document.querySelector('.cyr-pc-col')) return;
      var main = document.querySelector('main') || document.body; if(!main) return;
      var d = document.createElement('div');
      d.className = 'cyr-pc-col';
      d.innerHTML =
        '<b>' + (nombre ? nombre + ', cualquiera de estos ' : 'Cualquiera de estos ') + destino + ' sin pagar otro porte.</b> '
        + 'Con tu ' + PCTX + ' mientras el paquete siga abierto: <b class="cyr-pc-cd">—</b>. '
        + '<span style="opacity:.7">Y si no ves ninguno que te pida la pared, no pasa nada: lo tuyo sale igual.</span>';
      main.insertBefore(d, main.firstChild);
    }

    // ── CARRITO: suyo, y con el ahorro cantado ────────────────────────────
    // El tema deja el total de línea y el subtotal al precio de tarifa y solo
    // baja el total final: parecía que el descuento no se aplicaba. Se cogen
    // las cifras de /cart.js, que son las que va a cobrar Shopify de verdad.

    // Su descuento no está puesto: otro código lo ha desplazado, o ha caducado.
    // Ojo: si el que lo desplaza descuenta MAS, no se avisa (ver mas abajo).
    // Nunca pintar precios de escaparate sobre un carrito que cobra otra cosa.
    function avisarDescuentoPisado(descReal){
      if(document.querySelector('.cyr-pc-alerta')) return;
      var caja = document.querySelector('.cr-cart-total');
      if(!caja) return;
      var pct = Math.round(descReal * 100);
      var quien = nombre ? nombre + ', ' : '';
      var titulo, cuerpo;
      if(pct <= 0){
        titulo = quien + 'tu ' + PCTX + ' se ha soltado';
        cuerpo = 'Pasa al tocar el carrito. Ahora mismo esto está a precio de web, así que no lo pagues así: te lo vuelvo a poner yo.';
      } else {
        titulo = quien + 'tu ' + PCTX + ' no está puesto';
        cuerpo = 'Solo cabe un código por pedido, y ahora hay otro ocupando el sitio (te deja un −' + pct + '%). El tuyo es mejor. Te lo cambio yo.';
      }
      var d = document.createElement('div');
      d.className = 'cyr-pc-alerta';
      d.innerHTML =
        '<p class="cyr-pc-alerta__t">' + titulo + '</p>'
        + '<p class="cyr-pc-alerta__p">' + cuerpo + '</p>'
        + '<button type="button" class="cyr-pc-alerta__b">Ponerme mi ' + PCTX + '</button>';
      d.querySelector('button').addEventListener('click', function(){
        location.href = '/discount/' + encodeURIComponent(pase.code) + '?redirect=/cart';
      });
      caja.parentNode.insertBefore(d, caja);
    }

    // null = todavía sin comprobar · true = lleva su descuento · false = no lo lleva.
    // El carrito manda: es lo único que dice lo que Shopify va a cobrar.
    var carritoOk = null;
    var carritoPedido = false;
    function pintarCarrito(){
      if(!/\/cart/.test(location.pathname)) return;
      if(carritoPedido) return;
      carritoPedido = true;
      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
        var antes = (c.items_subtotal_price || 0) / 100;
        var paga  = (c.total_price || 0) / 100;
        var ahorro = Math.round((antes - paga) * 100) / 100;

        // Shopify solo deja UN código por carrito. Si el cliente ha metido otro
        // (PM10, un cupón viejo...), el suyo se cae y paga más de lo que le
        // enseñamos. Antes que mentirle: se lo decimos y se lo arreglamos.
        var descReal = antes > 0 ? (1 - paga / antes) : 0;

        // EL QUE MANDA ES EL CARRITO. Si el codigo que lleva puesto descuenta
        // MAS que su pase -le llego el correo de la campana con un 25 y su pase
        // es de 23-, se respeta el suyo y se pintan SUS precios. Antes esto
        // entraba por el "no es mi 20 clavado" y le plantaba un aviso diciendo
        // "el tuyo es mejor" con un boton que le BAJABA el descuento.
        if(descReal > PCT/100 + 0.005){ PCT = Math.round(descReal*100); PCTX = '\u2212'+PCT+'%'; }

        carritoOk = Math.abs(descReal - PCT/100) <= 0.005;

        // El título le habla a él pase lo que pase con el código
        var h0 = document.querySelector('h1');
        if(h0 && !h0.dataset.cyrPc){
          h0.dataset.cyrPc = '1';
          h0.textContent = nombre ? (nombre + ', este es tu carrito') : 'Este es tu carrito';
        }

        if(!carritoOk){ avisarDescuentoPisado(descReal); return; }
        if(ahorro <= 0) return;

        var eur = function(n){
          n = Math.round(n * 100) / 100;
          return '€' + (n % 1 === 0 ? String(n) : n.toFixed(2).replace('.', ','));
        };

        // 2. Total de línea y subtotal: al precio que se paga, con el tachado
        var zonaTotales = document.querySelector('.cart-recap, .cart__footer, .cr-cart-total') || document;
        var celdas = [].slice.call(document.querySelectorAll('td.text-end'))
          .concat([].slice.call(zonaTotales.querySelectorAll('.text-subdued')));
        celdas.forEach(function(el){
          if(el.dataset.cyrPc) return;
          var v = euros(el.textContent);
          if(v == null || v < 5) return;
          el.dataset.cyrPc = '1';
          el.innerHTML = '<span class="cyr-now">' + eur(precioPC(v)) + '</span>'
                       + '<span class="cyr-was">' + eur(v) + '</span>';
        });

        // 3. El ahorro, cantado en grande justo encima del total
        var caja = document.querySelector('.cr-cart-total');
        if(caja && !document.querySelector('.cyr-pc-ahorro')){
          var d = document.createElement('div');
          d.className = 'cyr-pc-ahorro';
          d.innerHTML =
            '<div class="cyr-pc-ahorro__fila">'
              + '<span class="cyr-pc-ahorro__l">Te ahorras</span>'
              + '<span class="cyr-pc-ahorro__n">' + eur(ahorro) + '</span>'
            + '</div>'
            + '<div class="cyr-pc-ahorro__sub">'
              + (nombre ? nombre + ', esto' : 'Esto') + ' viaja con tu pedido: un solo porte, un solo embalaje. '
              + 'Tu ' + PCTX + ' ya va aplicado y se cae en <b class="cyr-pc-cd">—</b>.'
            + '</div>';
          caja.parentNode.insertBefore(d, caja);
        }
      }).catch(function(){});
    }

    function tic(){
      var els=document.querySelectorAll('.cyr-pc-cd'); if(!els.length) return;
      var s=Math.floor((pase.end-Date.now())/1000);
      if(s<=0){ document.cookie='cyr_pc=; path=/; max-age=0'; location.reload(); return; }
      var h=Math.floor(s/3600), m=Math.floor((s%3600)/60);
      var txt = dos(h)+'h '+dos(m)+'m '+dos(s%60)+'s';
      els.forEach(function(e){ e.textContent = txt; });
    }

    // ── 6. Precios a su descuento (mismo método que la promo, sin tocarla)
    var NUM=/(\d[\d.]*,\d{2})|(\d[\d.]*)/;
    // EXACTO, no "bonito": el código de Shopify descuenta su porcentaje clavado, así
    // que lo que se enseña tiene que ser lo que se cobra. Si redondeamos a la
    // baja, el cliente ve 69 y paga 71,20 — y con razón se enfada.
    function precioPC(o){ return Math.round(o*(1-PCT/100)*100)/100; }
    function fmt(n){ return (Math.round(n*100)%100===0) ? String(Math.round(n)) : n.toFixed(2).replace('.',','); }
    function limpio(t){ return t.replace(/,00\b/,''); }
    function visible(el){ var c=el.cloneNode(true); c.querySelectorAll('.sr-only,[hidden],.cyr-was').forEach(function(s){s.remove();}); return (c.textContent||'').trim(); }
    function euros(t){ var m=(t||'').replace(/\s/g,'').match(NUM); if(!m) return null; var n=parseFloat(m[0].replace(/\./g,'').replace(',','.')); return isNaN(n)?null:n; }
    function marcar(el,modo){
      // Ya procesado: si no, se descuenta sobre lo ya descontado (pasó en el carrito)
      if(el.querySelector && el.querySelector(".cyr-now")) return;
      // Y al reves: el snippet de la campana (cyr-precios-campana) pinta sobre
      // estos mismos sitios y deja un .cyr-precio-campana. Descontar encima de
      // lo ya descontado enseña un precio que Shopify no va a cobrar.
      if(el.querySelector && el.querySelector(".cyr-precio-campana")) return;
      var t=visible(el), cur=euros(t); if(cur==null||cur<20) return;
      if(el.__pc!=null && Math.abs(cur-el.__pc)<0.005) return;
      var venta=precioPC(cur); if(venta>=cur) return;
      var oTxt=limpio(t), vTxt=oTxt.replace(NUM,fmt(venta)); el.__pc=venta;
      if(modo==='main'){
        el.innerHTML='<span class="cyr-now">'+vTxt+'</span>';
        var cmp=document.getElementById('cr-dynamic-compare'), wrap=document.getElementById('cr-compare-wrapper');
        if(cmp) cmp.textContent=oTxt; if(wrap) wrap.style.display='';
      } else {
        el.innerHTML='<span class="cyr-now">'+vTxt+'</span><span class="cyr-was">'+oTxt+'</span>';
      }
    }
    function barrer(){
      // Mentir aquí es cobrar de más: en el carrito se espera a la confirmación
      if(/\/cart/.test(location.pathname) && carritoOk !== true) return;
      var m=document.getElementById('cr-dynamic-price'); if(m) marcar(m,'main');
      document.querySelectorAll('.cr-price-current').forEach(function(el){ if(el.id!=='cr-dynamic-price') marcar(el,'card'); });
      document.querySelectorAll('sale-price,compare-at-price').forEach(function(el){ marcar(el,'card'); });
      // Tarjetas de tamaño ("95x37 cm · €119,00"): si no, enseñan el precio viejo
      document.querySelectorAll('.cr-data-price').forEach(function(el){ marcar(el,'card'); });
      ajustarPildora();
      juntarPrecios();
    }

    // El tema pinta el precio arriba y el tachado dos bloques más abajo. Con
    // descuento eso se lee fatal: se traen a la misma línea.
    function juntarPrecios(){
      var nuevo = document.getElementById('cr-dynamic-price');
      var viejo = document.getElementById('cr-dynamic-compare');
      if(!nuevo || !viejo) return;
      var fila = document.querySelector('.cyr-pc-fila');
      if(!fila){
        fila = document.createElement('div');
        fila.className = 'cyr-pc-fila';
        nuevo.parentNode.insertBefore(fila, nuevo.nextSibling);
      }
      if(viejo.parentNode !== fila){
        fila.appendChild(viejo);
        var pastilla = document.querySelector('.cr-save-pill');
        if(pastilla) fila.appendChild(pastilla);
        // El envoltorio original se queda vacío: fuera, si no deja un hueco
        var envoltorio = document.getElementById('cr-compare-wrapper');
        if(envoltorio && !envoltorio.textContent.trim()) envoltorio.style.display='none';
      }
    }

    // El tema pinta su propia etiqueta de ahorro ("AHORRAS UN 25%") con su
    // cálculo. Con el precio de cliente ya no cuadra, así que la recalculamos
    // sobre los precios que se están viendo de verdad.
    function ajustarPildora(){
      var p=document.querySelector('.cr-save-pill'); if(!p) return;
      var ahora=euros((document.getElementById('cr-dynamic-price')||{}).textContent);
      var antes=euros((document.getElementById('cr-dynamic-compare')||{}).textContent);
      if(ahora==null||antes==null||antes<=ahora) return;
      var pct=Math.round((antes-ahora)/antes*100);
      var txt='AHORRAS UN '+pct+'%';
      if(p.textContent.trim()!==txt) p.textContent=txt;
    }

    function run(){ pintarBarra(); tic(); barrer(); juntarPrecios(); pintarFicha(); pintarSinRiesgo(); pintarHome(); pintarColeccion(); pintarCarrito(); }
    setInterval(tic,1000);

    var arrancado = false;
    function arrancarPintado(){
      if(arrancado) return; arrancado = true;
      // Puede llamarse desde la respuesta del servidor antes de que el DOM
      // esté listo: entonces se espera, si no no habría nada que pintar.
      if(document.readyState === 'loading'){
        document.addEventListener('DOMContentLoaded', pintadoYa);
      } else {
        pintadoYa();
      }
    }
    function pintadoYa(){
      run();
      var n=0, iv=setInterval(function(){ pintarBarra(); barrer(); juntarPrecios(); pintarFicha(); pintarSinRiesgo(); pintarHome(); pintarColeccion(); pintarCarrito(); if(++n>60) clearInterval(iv); },350);
    }

    // Con sobre pendiente se espera a tenerlo (máx 2,5 s) para no pintar el
    // titular sin su nombre y dejarlo así. Sin sobre, se arranca ya.
    if(!esperandoPase) arrancarPintado();
  }catch(e){}
})();
